





























































































import Vue from "vue";
import moment from "moment-timezone";
import IconBookingArrowRight from "@/assets/icons/IconBookingArrowRight.vue";
import { RecordObject } from "@/views/customer-dashboard/types/index";
import { solveCurrencySymbol } from "@/common/common";
import StatusTag from "./StatusTag.vue";
import { getLocalizedText } from "@/utils/localize";

export default Vue.extend({
  name: "RequestCustomerLink",
  data: () => {
    return {
      timezone: moment.tz.guess() as string,
      status: "base" as string
    };
  },
  components: {
    IconBookingArrowRight,
    StatusTag
  },
  props: {
    email: {
      type: String,
      default: ""
    },
    record: {
      type: Object,
      default() {
        return {};
      }
    },
    company: {
      type: Object,
      default() {
        return {};
      }
    },
    office: {
      type: Object,
      default() {
        return {};
      }
    },
    resource: {
      type: Object,
      default() {
        return {};
      }
    },
    service: {
      type: Object,
      default() {
        return {};
      }
    },
    initialEmail: {
      type: String,
      default: null
    }
  },
  methods: {
    solveCurrencySymbol,
    solveTimeframeString(record: RecordObject, timezone: string) {
      const startTime = moment
        .unix(record.time)
        .tz(timezone)
        .format("HH:mm");
      const endTime = moment
        .unix(record.time + record.duration)
        .tz(timezone)
        .format("HH:mm");
      return [startTime, endTime].join("-");
    },
    solveDurationString(recordDuration: number) {
      const duration = moment.duration(recordDuration, "seconds");
      const hours = duration.hours() > 0 ? `${duration.hours()}h` : "";
      const minutes = duration.minutes() > 0 ? `${duration.minutes()}min` : "";

      if (!hours && !minutes) return "";

      return `${hours} ${minutes}`;
    },
    solveDayOfWeek(record: RecordObject, timezone: string) {
      return moment
        .unix(record.time)
        .locale(this.$i18n.locale)
        .tz(timezone)
        .format("ddd");
    },
    solveDate(time: number, timezone: string) {
      return moment
        .unix(time)
        .tz(timezone)
        .format("DD.MM.YYYY");
    },
    getPriceInCents(servicePrice: number) {
      const sPrice = servicePrice / 100;
      if (isNaN(sPrice)) return "";

      return sPrice.toFixed(2);
    },
    openRecordUrl(url: string): void {
      window.open(url);
    },
    getLocalizedText
    // TODO for later: allow reviews from customer dashboard as well; now only with link
    // reviewAvailable(record: RecordObject) {
    //   // TODO: timezone?
    //   // record:
    //   // - not .canceled
    //   // - has .review_token
    //   // - has .review_expiry in the future
    //   const {
    //     canceled,
    //     review_token,
    //     review_expiry,
    //     allocated_time_end
    //   } = record;
    //   if (
    //     !canceled &&
    //     review_token &&
    //     review_expiry > 0 &&
    //     allocated_time_end > 0
    //   ) {
    //     // record is in the past and its review token is still valid
    //     if (
    //       moment(allocated_time_end * 1000).isBefore(moment()) &&
    //       moment(review_expiry * 1000).isAfter(moment())
    //     ) {
    //       return true;
    //     }
    //   }
    //   return false;
    // },
    // handleReview(e: MouseEvent | KeyboardEvent) {
    //   e.preventDefault();
    //   // route to review view which is a subroute of this current route
    //   this.$router.push({
    //     name: "ReviewEntry",
    //     query: {
    //       email: this.$route.query.email,
    //       token: this.$route.query.token,
    //       expire: this.$route.query.expire,
    //       hash: this.$route.query.hash,
    //       review_token: this.record.review_token
    //     }
    //   });
    // }
  }
});
